/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Prep_Ahead_HelpInputs */

const en_editor_prep_ahead_help = /** @type {(inputs: Editor_Prep_Ahead_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dishly reminds you the evening before.`)
};

const de_editor_prep_ahead_help = /** @type {(inputs: Editor_Prep_Ahead_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dishly erinnert dich am Vorabend daran.`)
};

/**
* | output |
* | --- |
* | "Dishly reminds you the evening before." |
*
* @param {Editor_Prep_Ahead_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_prep_ahead_help = /** @type {((inputs?: Editor_Prep_Ahead_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Prep_Ahead_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_prep_ahead_help(inputs)
	return en_editor_prep_ahead_help(inputs)
});